// extracted by mini-css-extract-plugin
export default {"wrapper":"Content_wrapper__vftOJ","content":"Content_content__GUt2b","link":"Content_link__gZ-5c","top":"Content_top__ntQ5I"};